// src/onboarding/aha/ScoreBar.jsx
import React from "react";
import { motion } from "framer-motion";

export default function ScoreBar({ value }) {
  return (
    <div style={S.wrap}>
      <motion.div
        style={S.fill}
        animate={{ width: `${value}%` }}
        transition={{ duration: 0.9, ease: "easeOut" }}
      />
    </div>
  );
}

const S = {
  wrap: {
    width: "80%",
    height: 20,
    borderRadius: 20,
    background: "rgba(255,255,255,.2)",
    margin: "20px auto",
    overflow: "hidden",
  },
  fill: {
    height: "100%",
    background: "linear-gradient(90deg, #FF7C24, #ff9b24)",
    borderRadius: 20,
  },
};